module.exports = __webpack_public_path__ + "img/06-wide.09cdfb8d.svg";